import { get as apiGet } from 'api'

export const getAll = async tableState => apiGet('/DespatchAdvices/GetList', tableState)
